/* SolutionsSwitcherRenderer.js */

"use strict";
const _ = require('lodash');

class SolutionsSwitcherRenderer {
    constructor(model, rootElem) {
        this._model = model;
        this._rootElem = rootElem ? rootElem : document.createElement("solutions-switcher"); // TODO Setup the root Element
        this._rootElem.component = this._model;
        this._leftColElem = undefined;
        this._rightColElem = undefined;
        this._rowElems = [];
        this._dashboardLink = undefined;
        this.render();
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("Refresh", this._onRefresh = this._onRefresh.bind(this));
        this.rootElement.addEventListener("click", this._onHrefClicked = this._onHrefClicked.bind(this), true);
    }

    _unregisterListeners() {
        this._model.removeListener("Refresh", this._onRefresh);
        this.rootElement.removeEventListener("click", this._onHrefClicked);
    }

    // eslint-disable-next-line no-unused-vars
    _activeSolutionChanged(slnDef) {
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        // TODO set all class members to undefined here
        this._model = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;
        this._leftColElem = undefined;
        this._rightColElem = undefined;
        this._dashboardLink = undefined;
        return Promise.resolve();
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve/*,reject*/) => {
            this._renderThat();
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    // TODO Private Render Methods here

    _validGroup(map) {
        let hasLabel = _.isString(map.label);
        let hasItems = !_.isEmpty(map.items);
        return (hasLabel && hasItems);
    }

    _createDashboardItem() {
        const restricted = this._model.checkIfDashboardRestricted();

        let containerElem;
        if (restricted) {
            containerElem = document.createElement("icon-disabled-gl");

        } else {
            containerElem = document.createElement("a");
            containerElem.href = this._model._router.buildUrl(location.origin, { app: "GameConsole", s: "Dashboard", sln: null, sr: null, rd: {}, ra: "dashboard" });
        }
        containerElem.setAttribute('id', 'sln-dashboard');
        // icon

        let iconElem = document.createElement('actionable-icon-gl');
        iconElem.dataset.icon = "solution.dashboard";
        iconElem.classList.add('dashboard-icon');

        containerElem.appendChild(iconElem);
        // icon label
        let iconLabelElem = document.createElement("icon-label-gl");
        iconLabelElem.innerText = "My Dashboards";
        containerElem.appendChild(iconLabelElem);
        return containerElem;

    }

    _renderThat(showTypeName = true) {
        this._removeThat();
        let types = this._model.getSolutionTypes();
        let lineBreak = document.createElement("line-break-gl");
        if(!this._leftColElem) {
            this._leftColElem = document.createElement("col-gl");
            this._leftColElem.classList.add("left-container");
            this._dashboardLink = this._createDashboardItem();
            this._leftColElem.appendChild(this._dashboardLink);

            this._rootElem.appendChild(this._leftColElem);

            this._rightColElem = document.createElement("col-gl");
            this._rightColElem.classList.add("right-container");
        } else {
            if(this._leftColElem.contains(this._dashboardLink)) {
                this._leftColElem.removeChild(this._dashboardLink);
            }
            this._dashboardLink = this._createDashboardItem();
            this._leftColElem.appendChild(this._dashboardLink);
        }

        types.forEach((typeName) => {

            // Row
            let rowElem = document.createElement("row-gl");
            if (showTypeName) {
                let rowLabelElem = document.createElement("row-label-gl");
                rowLabelElem.innerText = typeName;
                rowElem.appendChild(rowLabelElem);
            }
            let rowItemsContainerElem = document.createElement("row-items-container-gl");
            rowElem.appendChild(rowItemsContainerElem);

            // Solutions
            let navMap = this._model.getSolutionsForGroup(typeName);
            _.forEach(navMap, (solution) => {
                let nav = solution.registeredObj;
                let details = solution.registeredDetails;
                const restricted = this._model.checkIfRestricted(nav);

                if (!nav.hidden) {
                    let containerElem = this._createIconDom(nav, details, nav.disabled, restricted);
                    rowItemsContainerElem.appendChild(containerElem);
                }
            });

            // Differentiate short from long row for CSS styling
            if (rowItemsContainerElem.children.length < 3) {
                rowElem.classList.add('short-row');
            }
            else {
                rowElem.classList.add('long-row');
                this._rowElems.push(lineBreak);
                this._rootElem.appendChild(lineBreak);
            }

            this._rowElems.push(rowElem);
            this._rightColElem.appendChild(rowElem);

        });
        this._rootElem.appendChild(this._rightColElem);
    }

    _createIconDom(nav, details, hidden, restricted) {
        // item container
        let containerElem;
        if (hidden || restricted) {
            containerElem = document.createElement("icon-disabled-gl");
            containerElem.classList.toggle("hidden", hidden);

        } else {
            containerElem = document.createElement("a");
            containerElem.href = this._model.getSolutionUrl(details.name);
        }
        containerElem.setAttribute('id', 'sln-' + nav.name);
        // icon
        let iconElem = this._getSolutionSwitcherIconElem(nav);
        containerElem.appendChild(iconElem);
        // icon label
        let iconLabelElem = document.createElement("icon-label-gl");
        iconLabelElem.innerText = nav.label;
        containerElem.appendChild(iconLabelElem);
        return containerElem;
    }

    _getSolutionSwitcherIconElem(item) {
        let iconElem = document.createElement("solution-switcher-icon-gl");
        iconElem.innerHTML = item.icon;
        if (item.disabled) {
            iconElem.disabled = true;
        }
        return iconElem;
    }

    _removeThat() {
        if (!_.isEmpty(this._rowElems)) {
            _.each(this._rowElems, (rowElem) => {
                if (rowElem.hasChildNodes()) {
                    while (rowElem.firstChild) {
                        rowElem.firstChild.remove();
                    }
                }
                rowElem.remove();
            });
        }
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onRefresh() {
        this.render();
    }

    _onHrefClicked(evt) {
        const path = evt.path || (evt.composedPath && evt.composedPath());
        path.slice(0,5).forEach(tag => {
            if(tag.tagName === 'A') {
                this.model._onHrefClicked();
            }
        });

        // if (_.get(evt, "path[2].tagName") === 'A') {
        //     this.model._onHrefClicked();
        // }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    // TODO - Nobody should be using methods on a Renderer directly so make all these methods private

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = SolutionsSwitcherRenderer;
